import React from 'react';
import styled from 'styled-components';
import {Button} from '@material-ui/core';

const FooterContainer = styled.div`
  background-color: #e45306;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  display: grid;
    grid-column-start: 1;
    grid-column-end 4;
`

const FooterText = styled.h4`
  align-self: center;
  grid-column: 2 / 4;
  color: white;
  margin-left: 12px;
`;

const FooterLink = styled(Button)`
  margin: 8px;
  align-self: center;
  grid-column: 5 / 6;
  border: 1px solid white !important;
  border-radius: 8px !important;
  margin-right: 16px !important;
`;

function Header() {
  return (
    <FooterContainer>
      <FooterText>Conheça o custo e o preço de venda de suas receitas com o Menu Control!</FooterText>
      <FooterLink variant="contained" color="primary" href="https://app.menucontrol.com.br/#/register">Crie uma conta gratuita</FooterLink>
    </FooterContainer>
  );
}

export default Header;
